import request from '@/plugins/request'

export function getDashboadCardInfo() {
    return request({
        url: '/v1/Charts/GetDashboadCardInfo',
        method: 'post'
    })
}

export function getLastTop(dateType) {
    return request({
        url: '/v1/Charts/GetLastTop',
        method: 'post',
        data: {
            dateType: dateType,
            topNum: 25
        }
    })
}

export function getChartByKeyWord(id) {
    return request({
        url: '/v1/Charts/GetChartByKeyWord',
        method: 'post',
        data: {
            id: id
        }
    })
}

export function getChartKeyWordBottomChart(id) {
    return request({
        url: '/v1/Charts/GetChartKeyWordBottomChart',
        method: 'post',
        data: {
            id: id
        }
    })
}



export function getChartByKeyType(id,dm) {
    return request({
        url: '/v1/Charts/GetChartByKeyType',
        method: 'post',
        data: {
            id: id,
            dm: dm
        }
    })
}

export function getChartBySearch(key, parids) {
    return request({
        url: '/v1/Charts/GetChartBySearch',
        method: 'post',
        data: {
            key: key,
            parIds: parids,
        }
    })
}

export function getWeekChartByKeyWord(wci_ids, tk_ids) {
    return request({
        url: '/v1/Charts/GetWeekChartByKeyWord',
        method: 'post',
        data: {
            wciIds: wci_ids,
            tkIds: tk_ids
        }
    })
}


export function getAllWeekList() {
    return request({
        url: '/v1/Charts/GetAllWeekList',
        method: 'post',
    })
}


export function getChartWeekTop(st,ed) {
    return request({
        url: '/v1/Charts/GetChartWeekTop',
        method: 'post',
        data:{
            stYmd: st,
            edYmd: ed
        }
    })
}



export function getSbChartByKeyWord(id) {
    return request({
        url: '/v1/Charts/GetSbChartByKeyWord',
        method: 'post',
        data: {
            id: id
        }
    })
}

export function getEtfTop(index, size, type) {
    return request({
        url: '/v1/Charts/GetEtfTop',
        method: 'post',
        data: {
            pageIndex: index,
            pageSize: size,
            divType: type
        }
    })
}
export function getEtfChartByKeyWord(id) {
    return request({
        url: '/v1/Charts/GetEtfChartByKeyWord',
        method: 'post',
        data: {
            id: id
        }
    })
}

export function getEtfPriceList(id) {
    return request({
        url: '/v1/Charts/GetEtfPriceList',
        method: 'post',
        data: {
            id: id
        }
    })
}